module.exports = __webpack_public_path__ + "static/img/KissOfDeath.9812f38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KissOfDeath.jpg
// module id = URf2
// module chunks = 0